export default "__VITE_ASSET__DmG_CN39__"